// 宮崎通クイズ - 10問1セット×10セット
// 究極の宮崎通クイズ：あなたの地元愛を試す100の質問

import { quizData } from './quizData';

export const quizSets = [
  {
    id: 1,
    title: "セット1: 宮崎ソウルフード編 (前半)",
    category: "宮崎ソウルフード",
    questions: quizData.slice(0, 10)
  },
  {
    id: 2,
    title: "セット2: 宮崎ソウルフード編 (中盤)",
    category: "宮崎ソウルフード",
    questions: quizData.slice(10, 20)
  },
  {
    id: 3,
    title: "セット3: 宮崎ソウルフード編 (後半)",
    category: "宮崎ソウルフード",
    questions: quizData.slice(20, 30)
  },
  {
    id: 4,
    title: "セット4: 定番お土産・スイーツ編",
    category: "定番お土産・スイーツ",
    questions: quizData.slice(30, 40)
  },
  {
    id: 5,
    title: "セット5: スイーツ & 地元企業・ランドマーク編",
    category: "スイーツ・地元企業",
    questions: quizData.slice(40, 50)
  },
  {
    id: 6,
    title: "セット6: 地元企業 & うまいもん編 (前半)",
    category: "地元企業・うまいもん",
    questions: quizData.slice(50, 60)
  },
  {
    id: 7,
    title: "セット7: 地元企業 & うまいもん編 (後半)",
    category: "地元企業・うまいもん",
    questions: quizData.slice(60, 70)
  },
  {
    id: 8,
    title: "セット8: うまいもん & ローカルCM編 (前半)",
    category: "うまいもん・ローカルCM",
    questions: quizData.slice(70, 80)
  },
  {
    id: 9,
    title: "セット9: ローカルCM編 (中盤)",
    category: "ローカルCM",
    questions: quizData.slice(80, 90)
  },
  {
    id: 10,
    title: "セット10: ローカルCM編 (後半)",
    category: "ローカルCM",
    questions: quizData.slice(90, 100)
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
